<script setup>
import { ref } from "vue";
import Datepicker from "vue3-datepicker";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
const props = defineProps({
    context: Object,
});

const initial_date = props.context._value != null ? props.context._value : "";
const date = ref(new Date(initial_date));
const date_format = "d MMMM, yyyy";

function handleInput(modelData) {
    props.context.node.input(format(modelData, "yyyy-MM-dd"));
}
</script>

<template>
    <datepicker
        v-model="date"
        :inputFormat="date_format"
        :locale="fr"
        class="date-picker"
        @update:modelValue="handleInput"
    />
</template>
